import useTermOfUseDisclaimer from 'app/hooks/useTermOfUseDisclaimer';
import useHTMLLinkClickHandler from 'app/hooks/useHTMLLinkClickHandler';
import useLinkClickCapture from 'app/hooks/useLinkClickCapture';
import useWebchatVersion from 'app/hooks/useWebchatVersion';
import { ChatVersion } from 'app/copied/constants/common';
import { cx } from '@twind/core';

import OstroDynamicContent from '../../../components/OstroDynamicContent';
import CloseIcon from '../../../components/icons/CloseIcon';
import useNamespacedLocalStorage from '../../../hooks/useNamespacedLocalStorage';

export default function TailorPrivacyBanner({ footerText }: { footerText?: string[] }) {
  const handleHTMLLinkClickHandler = useHTMLLinkClickHandler();
  const webchatVersion = useWebchatVersion();
  const a = useLinkClickCapture();
  const [showPrivacyBanner, setShowPrivacyBanner] = useNamespacedLocalStorage('showPrivacyBanner', true);

  const tou: string = useTermOfUseDisclaimer() || 'ToU/PP Placeholder';
  const closeIconClassName = webchatVersion === ChatVersion.v4_1 ? 'w-3 h-3' : 'w-2 h-2';

  if (!showPrivacyBanner) return null;

  return (
    <div
      id="ostro-tailor-privacy-banner-container"
      className="bg-black py-3 px-10 relative"
      onClickCapture={a}
    >
      <OstroDynamicContent
        id="ostro-tailor-privacy-banner-text"
        content={tou}
        onClick={handleHTMLLinkClickHandler}
        className="text-(xs [#9E9FA3] center) font-medium"
      />

      <button
        id="ostro-tailor-privacy-banner-close-button"
        className="absolute top-4 right-4"
        onClick={() => setShowPrivacyBanner(false)}
      >
        <CloseIcon className={cx('text-white fill-white', closeIconClassName)} />
      </button>
      {footerText?.map(
        (text, index) =>
          text && (
            <OstroDynamicContent
              key={index}
              className="mt-2 [&_p]:(text-([#9E9FA3]) text-center text-xs font-medium :last-child:mb-0)"
              onClick={handleHTMLLinkClickHandler}
              content={text}
            />
          )
      )}
    </div>
  );
}
